import React, { Component } from 'react';
import { Container, Navbar, Nav, NavDropdown } from 'react-bootstrap';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { Link } from 'react-router-dom';
import logo from '../dollar.png';
import { TypeAHeadNavigate } from '../hooks/TypeAHeadNavigate';
import PubSub from 'pubsub-js';
import { getCookie, removeCookie} from '../service/Cookie';
import DBService from '../service/DBService';

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedStock: [],
            redirect: false,
            isLoggedIn: false,
            userId: ''
        };
    }
    componentDidMount() {
        this.userLoggedInTrigger = PubSub.subscribe('userLoggedIn', (topic, data) => {
            // let isLoggedIn = data.isLoggedIn;
            let userId = data.userId;
            console.log('UserLogged In', data);
            this.setState({ isLoggedIn: true, userId: userId });
        });
        this.signInFromCookie();
    }

    componentWillUnmount() {
        PubSub.unsubscribe(this.userLoggedInTrigger);
    }

    signInFromCookie() {
        let cookieValue = getCookie();
        console.log('Header Cookie', cookieValue);
        if (cookieValue !== undefined && cookieValue.userId !== undefined && cookieValue.password !== undefined) {
            console.log('Cookie found', cookieValue);
            let body = {
                'userId': cookieValue.userId,
                'password': cookieValue.password
            }

            DBService.userSignin(body)
                .then(result => {
                    result = result.data;
                    console.log('User signin Cookie', result);
                    if (result !== undefined && result.length !== undefined && result.length <= 0) {
                        console.log('Cookie No userId found');
                    } else {
                        if (result[0] !== undefined && result[0].isEmailVerified === 'No') {
                            console.log('Cookie Email not validated');
                        } else {
                            //Remember me
                            console.log('Cookie logged in succesfully');
                            this.setState({ isLoggedIn: true, userId: cookieValue.userId });
                        }
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({ error: 'Error Signing in with EmailId, please try again' });
                });
        } 
        // else {
        //     let user = getUserDetails();
        //     console.log('No Cookie but getting from the session');
        //     if (user !== undefined){
        //         console.log('No Cookie but logged in succesfully after the login screen');
        //         setCookie(user);
        //         this.setState({ isLoggedIn: true, userId: user.userId });
        //     } 
        // }
    }

    onChangeStockSelection(data) {
        console.log('on change data', data.selected[0]);
        this.setState({
            selectedStock: data.selected,
            redirect: true
        });
    }

    signOut = () => {
        removeCookie();
        this.setState({ isLoggedIn: false, userId: '' });
    }

    render() {
        return (
            <>
                <Navbar bg="dark" variant="dark" expand="xl">
                    <Container fluid className="p-0">
                        <Navbar.Brand href="/" style={{ fontSize: "18px" }}>
                            <img src={logo} alt="Financial Market Visualization" width="40" height="30" className="d-inline-block align-top" />
                            Financial Market Visualization
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav className="me-auto">
                                {/* <Link className="nav-link" to="/">Home</Link> */}
                                <NavDropdown title="Markets" id="basic-nav-dropdown10">
                                    <NavDropdown.Item as={Link} to="/stocks/markets">Looser/Gainer/Active/...</NavDropdown.Item>
                                    <NavDropdown.Item as={Link} to="/news">News/Articles</NavDropdown.Item>
                                    {/* <NavDropdown.Item as={Link} to="/maps">Maps</NavDropdown.Item> */}
                                    <NavDropdown.Item as={Link} to="/insider">Insider</NavDropdown.Item>
                                    <NavDropdown.Item as={Link} to="/ipoCalender">IPO Calender</NavDropdown.Item>
                                    <NavDropdown.Item as={Link} to="/earningRelease">Earning Release Calender</NavDropdown.Item>
                                    <NavDropdown.Item as={Link} to="/economicCalender">Economic Events Calender</NavDropdown.Item>
                                    <NavDropdown.Item as={Link} to="/stockDividend">Stock Dividend Calender</NavDropdown.Item>
                                    <NavDropdown.Item as={Link} to="/ats">Alternative Trading System(Dark Pool)</NavDropdown.Item>
                                    <NavDropdown.Item as={Link} to="/upgradeDowngrade">Upgrades or Downgrades</NavDropdown.Item>
                                    <NavDropdown.Item as={Link} to="/senateTrading">Senate trading</NavDropdown.Item>
                                </NavDropdown>
                                <NavDropdown title="Maps" id="basic-nav-dropdown10">
                                    <NavDropdown.Item as={Link} to="/sp500Heatmap">S&P 500</NavDropdown.Item>
                                    <NavDropdown.Item as={Link} to="/usSectorHeatmap">US sectors</NavDropdown.Item>
                                </NavDropdown>

                                {/* <Link className="nav-link" to="/performance">Performance</Link> */}
                                <Link className="nav-link" to="/screener">Screener</Link>
                                <Link className="nav-link" to="/chart/AAPL">Chart/Algorithm</Link>
                                <NavDropdown title="Crypto/Forex/.." id="basic-nav-dropdown20">
                                    <NavDropdown.Item as={Link} to="/indices">Indices</NavDropdown.Item>
                                    <NavDropdown.Item as={Link} to="/crypto">Crypto</NavDropdown.Item>
                                    <NavDropdown.Item as={Link} to="/forex">Forex</NavDropdown.Item>
                                    <NavDropdown.Item as={Link} to="/commodity">Commodities</NavDropdown.Item>
                                    <NavDropdown.Item as={Link} to="/etf">ETF</NavDropdown.Item>
                                    <NavDropdown.Item as={Link} to="/mutualfund">Mutual Funds</NavDropdown.Item>
                                </NavDropdown>
                                {this.state.isLoggedIn ? (
                                    <NavDropdown title=<i className={'fa fa-user'}> {this.state.userId.substr(0, 9)}</i> id="basic-nav-dropdown20">
                                        <NavDropdown.Item as={Link} to="/" disabled>User: {this.state.userId}</NavDropdown.Item>
                                        <NavDropdown.Divider />
                                        <NavDropdown.Item as={Link} to="/notifications">Notifications</NavDropdown.Item>
                                        <NavDropdown.Item as={Link} to="/news-keyword-search-alert">News Keyword Alert</NavDropdown.Item>
                                        <NavDropdown.Item as={Link} to="/price-alert" disabled>Price Alert (Soon)</NavDropdown.Item>
                                        <NavDropdown.Item as={Link} to="/portfolio" >Portfolio</NavDropdown.Item>
                                         {/* <NavDropdown.Item as={Link} to="/portfolioAverage" >Portfolio Average(Soon)</NavDropdown.Item> */}
                                        <NavDropdown.Divider />
                                        <NavDropdown.Item as={Link} to="/settings">Settings</NavDropdown.Item>
                                        <NavDropdown.Item as={Link} to="/" onClick={this.signOut}>Sign Out</NavDropdown.Item>
                                    </NavDropdown>
                                ) : <></>}
                                {!this.state.isLoggedIn ? (
                                    <NavDropdown title=<i className={'fa fa-user'}> Sign Up/In</i> id="basic-nav-dropdown20">
                                        <NavDropdown.Item as={Link} to="/notifications" disabled>Notifications</NavDropdown.Item>
                                        <NavDropdown.Item as={Link} to="/news-keyword-search-alert" disabled>News Keyword Alert</NavDropdown.Item>
                                        <NavDropdown.Item as={Link} to="/price-alert" disabled>Price Alert</NavDropdown.Item>
                                        <NavDropdown.Item as={Link} to="/portfolio" disabled>Portfolio</NavDropdown.Item>
                                         {/* <NavDropdown.Item as={Link} to="/portfolioAverage" disabled>Portfolio Average</NavDropdown.Item> */}
                                        <NavDropdown.Divider />
                                        <NavDropdown.Item as={Link} to="/signup">Sign Up (Free)</NavDropdown.Item>
                                        <NavDropdown.Item as={Link} to="/signin">Sign In</NavDropdown.Item>
                                    </NavDropdown>
                                ) : <></>}
                            </Nav>
                        </Navbar.Collapse>
                        <TypeAHeadNavigate />
                    </Container>
                </Navbar>
            </>
        );
    }
}

export default Header;
